import { Link } from "react-router-dom";
import { usePublicSiteContent } from "../../hooks/useSiteContent";
import { telHref, whatsappUrl } from "../../lib/siteContentStore";

export default function Footer() {
  const content = usePublicSiteContent();

  return (
    <footer className="bg-farm-earth-pale border-t border-farm-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-[1.3fr_0.75fr_1fr_1fr] gap-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center rounded-full overflow-hidden bg-farm-earth-light">
                <img
                  src="https://public.readdy.ai/ai/img_res/73cf5855-ea32-42f4-956b-881be407de25.png"
                  alt={content.brandName}
                  className="w-9 h-9 object-contain"
                />
              </div>
              <div>
                <span className="block font-heading font-bold text-lg text-farm-brown">
                  EVREN ÇİFTLİĞİ
                </span>
                <span className="block font-body text-[10px] tracking-[0.24em] text-farm-earth font-bold">
                  KURBANLIK • ADAKLIK
                </span>
              </div>
            </div>
            <p className="font-body text-sm text-farm-muted leading-relaxed max-w-md">
              Kurbanlık, adaklık, hisseli satış, kesim ve teslimat süreçlerinde güvenilir ve düzenli çiftlik hizmeti.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-farm-brown mb-3">Sayfalar</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: "Ana Sayfa", path: "/" },
                { label: "Hakkımızda", path: "/bizim" },
                { label: "Hizmetler", path: "/hizmetler" },
                { label: "Müşteri Girişi", path: "/giris" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="font-body text-sm text-farm-muted hover:text-farm-brown transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-farm-brown mb-3">İletişim</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <a href={`tel:${telHref(content)}`} className="font-body text-sm text-farm-muted hover:text-farm-brown">
                  {content.contactPhone}
                </a>
              </li>
              <li>
                <a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="font-body text-sm text-farm-muted hover:text-farm-brown">
                  WhatsApp ile kayıt
                </a>
              </li>
              <li>
                <a
                  href={content.mapsUrl || "#"}
                  target="_blank"
                  rel="nofollow noopener"
                  className="font-body text-sm text-farm-muted hover:text-farm-brown whitespace-pre-line"
                >
                  {content.address || "Çatalca – İnceğiz Yolu\nİstanbul, Türkiye"}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-sm text-farm-brown mb-3">Bizi Takip Edin</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-farm-brown text-white hover:bg-farm-earth transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-lg" />
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-farm-brown text-white hover:bg-farm-earth transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-lg" />
              </a>
              <a href={whatsappUrl(content)} target="_blank" rel="nofollow noopener" className="w-10 h-10 flex items-center justify-center rounded-full bg-farm-green text-white hover:bg-farm-green/90 transition-colors" aria-label="WhatsApp">
                <i className="ri-whatsapp-line text-lg" />
              </a>
              <a href={content.mapsUrl || "#"} target="_blank" rel="nofollow noopener" className="w-10 h-10 flex items-center justify-center rounded-full bg-farm-earth text-white hover:bg-farm-brown transition-colors" aria-label="Konum">
                <i className="ri-map-pin-line text-lg" />
              </a>
            </div>
            <a
              href={content.mapsUrl || "#"}
              target="_blank"
              rel="nofollow noopener"
              className="mt-4 inline-flex items-center gap-2 font-body text-sm font-bold text-farm-earth hover:text-farm-brown"
            >
              Yol Tarifi Al
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <div className="mt-8 border-t border-farm-border pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-xs text-farm-muted">
            &copy; {new Date().getFullYear()} {content.brandName}. Tüm hakları saklıdır.
          </p>
          <p className="font-body text-xs text-farm-muted">
            Güvenilir • Helal • Hijyenik
          </p>
        </div>
      </div>
    </footer>
  );
}
